import { toast } from 'react-toastify';

export function handlerError(message: string) {
  toast(message, {
    toastId: 'common.error.message',
  });
}
